export default "__VITE_ASSET__10d521a9__"